export const drawerItemsMain = [
  {
    key: "ChinaTracker",
    title: "China Tracker",
    routes: [
      {
        nav: "ChinaTrackerReport",
        routeName: "ChinaTrackerReport",
        title: "China Tracker Report",
      },
    ],
  },
  {
    key: "ChinaShipment",
    title: "China Shipment",
    routes: [
      {
        nav: "ChinaShipmentReport",
        routeName: "ChinaShipmentReport",
        title: "China Shipment Report",
      },
    ],
  },
];
